// Persistent per-device id used only as a signup-abuse signal (never for auth).
const KEY = "chambanow_device_id_v1";

export function getDeviceFingerprint() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `d_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return "";
  }
}
